class PasCollection extends HTMLElement {
  connectedCallback() {
    this.classList.add('is-enhanced');
    this.form = this.querySelector('[data-collection-filters]');
    this.drawer = this.querySelector('[data-filter-drawer]');
    this.overlay = this.querySelector('[data-filter-overlay]');
    this.openButton = this.querySelector('[data-filter-open]');
    this.closeButton = this.querySelector('[data-filter-close]');
    this.lastFocus = null;
    this.desktopMedia = window.matchMedia('(min-width: 48rem)');

    this.openButton?.addEventListener('click', () => this.openFilters());
    this.closeButton?.addEventListener('click', () => this.closeFilters());
    this.overlay?.addEventListener('click', () => this.closeFilters());
    this.form?.querySelectorAll('input[type="checkbox"], input[type="number"]').forEach((input) => {
      input.addEventListener('change', () => this.form.requestSubmit());
    });
    this.querySelector('[data-sort-by]')?.addEventListener('change', (event) => {
      event.target.form?.requestSubmit();
    });
    this.addEventListener('click', (event) => this.handleLoadMore(event));
    this.addEventListener('keydown', (event) => this.handleKeydown(event));
    this.syncDrawerAccessibility();
    this.desktopMedia.addEventListener?.('change', () => this.syncDrawerAccessibility());
  }

  syncDrawerAccessibility() {
    if (!this.drawer || this.drawer.classList.contains('is-open')) return;
    this.drawer.setAttribute('aria-hidden', this.desktopMedia.matches ? 'false' : 'true');
  }

  openFilters() {
    if (!this.drawer) return;
    this.lastFocus = document.activeElement;
    this.drawer.classList.add('is-open');
    this.overlay?.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    this.openButton?.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('pas-lock-scroll');
    this.closeButton?.focus();
  }

  closeFilters() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.overlay?.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    this.openButton?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('pas-lock-scroll');
    this.lastFocus?.focus?.();
  }

  handleKeydown(event) {
    if (!this.drawer?.classList.contains('is-open')) return;
    if (event.key === 'Escape') {
      this.closeFilters();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...this.drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  async handleLoadMore(event) {
    const button = event.target.closest('[data-collection-load-more]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();
    button.setAttribute('aria-busy', 'true');
    const originalText = button.textContent;
    button.textContent = button.dataset.loadingText || 'Loading…';
    try {
      const url = new URL(button.href, window.location.origin);
      url.searchParams.set('section_id', this.dataset.sectionId);
      const response = await fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
      const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = documentFragment.querySelector('[data-collection-grid]');
      const currentGrid = this.querySelector('[data-collection-grid]');
      if (!nextGrid || !currentGrid) throw new Error('Collection response was incomplete');
      [...nextGrid.children].forEach((card) => currentGrid.append(card));
      const nextButton = documentFragment.querySelector('[data-collection-load-more]');
      if (nextButton) {
        button.href = nextButton.href;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      } else {
        button.closest('.pas-discovery__load')?.remove();
      }
    } catch (error) {
      console.error(error);
      window.location.assign(button.href);
    }
  }
}

if (!customElements.get('pas-collection')) customElements.define('pas-collection', PasCollection);
